class NsrStickyBar extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.button = this.querySelector('[data-nsr-sticky-add]');
    this.mainForm = document.querySelector(`#product-form-${this.sectionId}, form[data-type="add-to-cart-form"]`);
    this.submitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);

    if (this.button && this.submitButton) {
      this.button.addEventListener('click', () => this.submitButton.click());
    }

    this.observeMainButton();
  }

  observeMainButton() {
    const anchor = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    if (!anchor || !('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('nsr-sticky-bar--visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    io.observe(anchor);
  }
}

customElements.define('nsr-sticky-bar', NsrStickyBar);
